import { Dialog, DialogContent, DialogTitle } from "../Dialog";
import { Spinner } from "../Spinner";

const ModalSpinnerFallback = () => {
  return (
    <Dialog open>
      <DialogContent
        showBorder
        className="w-full max-w-[400px] !bg-card-bg !p-6 max-[600px]:overflow-x-hidden"
        closeBtnClassName="!bg-[transparent]"
        portalClassName="backdrop-blur-sm"
        onBackBtnClassName="!bg-[transparent]"
      >
        <DialogTitle className="hidden">Spinner</DialogTitle>
        <Spinner />
      </DialogContent>
    </Dialog>
  );
};

export default ModalSpinnerFallback;
